export default __webpack_public_path__ + "static/media/icons8-visa.4cc6ec3b.svg";